import GlobalHeader from "../../../../Site/gulp/scripts/typescript/modules/global-header";
import SlideToggle from "../../../../Site/gulp/scripts/typescript/modules/helpers";
import ShowContent from "../../../../Site/gulp/scripts/typescript/modules/show-content";
import HelpForm from "../typescript/modules/help-form";
import LiveChatOpen from "../../../../Site/gulp/scripts/typescript/modules/live-chat-open";
import HelpButtonVoting from "../typescript/modules/help-button-voting";
import FileUpload from "../../../../Site/gulp/scripts/typescript/modules/file-upload";
import NewsletterSubscription from "../../../../Site/gulp/scripts/typescript/modules/newsletter-subscription";

new GlobalHeader();

new SlideToggle();

new ShowContent();

new HelpForm();

new LiveChatOpen();

new HelpButtonVoting();

const fileUploads = document.querySelectorAll('.js-file-drop-area') as NodeListOf<HTMLElement>;
for (let i = 0; i < fileUploads.length; i++) {
	new FileUpload(fileUploads[i]);
}

new NewsletterSubscription(document.querySelector(".js-newsletter-form") as HTMLFormElement);
